// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color */
.text-c1 {
  color: #e5e5e5;
}

.bg-c1 {
  background-color: #e5e5e5;
}

.bg-h-c1 {
  background-color: #e5e5e5;
}

.bc-c1 {
  border-color: #e5e5e5;
}

.text-c2 {
  color: #180065;
}

.bg-c2 {
  background-color: #180065;
}

.bg-h-c2 {
  background-color: #180065;
}

.bc-c2 {
  border-color: #180065;
}

.text-c3 {
  color: #f9f9f9;
}

.bg-c3 {
  background-color: #f9f9f9;
}

.bg-h-c3 {
  background-color: #f9f9f9;
}

.bc-c3 {
  border-color: #f9f9f9;
}

.text-c4 {
  color: #556080;
}

.bg-c4 {
  background-color: #556080;
}

.bg-h-c4 {
  background-color: #556080;
}

.bc-c4 {
  border-color: #556080;
}

.text-c5 {
  color: #6c6c6c;
}

.bg-c5 {
  background-color: #6c6c6c;
}

.bg-h-c5 {
  background-color: #6c6c6c;
}

.bc-c5 {
  border-color: #6c6c6c;
}

.text-c6 {
  color: #dff5fb;
}

.bg-c6 {
  background-color: #dff5fb;
}

.bg-h-c6 {
  background-color: #dff5fb;
}

.bc-c6 {
  border-color: #dff5fb;
}

.text-c7 {
  color: #dff9e1;
}

.bg-c7 {
  background-color: #dff9e1;
}

.bg-h-c7 {
  background-color: #dff9e1;
}

.bc-c7 {
  border-color: #dff9e1;
}

.text-c8 {
  color: #dfedff;
}

.bg-c8 {
  background-color: #dfedff;
}

.bg-h-c8 {
  background-color: #dfedff;
}

.bc-c8 {
  border-color: #dfedff;
}

.text-c9 {
  color: #fee7e5;
}

.bg-c9 {
  background-color: #fee7e5;
}

.bg-h-c9 {
  background-color: #fee7e5;
}

.bc-c9 {
  border-color: #fee7e5;
}

.text-c10 {
  color: #b9e1ec;
}

.bg-c10 {
  background-color: #b9e1ec;
}

.bg-h-c10 {
  background-color: #b9e1ec;
}

.bc-c10 {
  border-color: #b9e1ec;
}

.text-c11 {
  color: #bfedc2;
}

.bg-c11 {
  background-color: #bfedc2;
}

.bg-h-c11 {
  background-color: #bfedc2;
}

.bc-c11 {
  border-color: #bfedc2;
}

.text-c12 {
  color: #b8ceeb;
}

.bg-c12 {
  background-color: #b8ceeb;
}

.bg-h-c12 {
  background-color: #b8ceeb;
}

.bc-c12 {
  border-color: #b8ceeb;
}

.text-c13 {
  color: #f2d0cd;
}

.bg-c13 {
  background-color: #f2d0cd;
}

.bg-h-c13 {
  background-color: #f2d0cd;
}

.bc-c13 {
  border-color: #f2d0cd;
}

.text-c14 {
  color: #0d0d0d;
}

.bg-c14 {
  background-color: #0d0d0d;
}

.bg-h-c14 {
  background-color: #0d0d0d;
}

.bc-c14 {
  border-color: #0d0d0d;
}

.text-c15 {
  color: #424242;
}

.bg-c15 {
  background-color: #424242;
}

.bg-h-c15 {
  background-color: #424242;
}

.bc-c15 {
  border-color: #424242;
}

.text-c16 {
  color: #d7dff7;
}

.bg-c16 {
  background-color: #d7dff7;
}

.bg-h-c16 {
  background-color: #d7dff7;
}

.bc-c16 {
  border-color: #d7dff7;
}

.text-c17 {
  color: #aebfef;
}

.bg-c17 {
  background-color: #aebfef;
}

.bg-h-c17 {
  background-color: #aebfef;
}

.bc-c17 {
  border-color: #aebfef;
}

.text-c18 {
  color: #6c6c6c;
}

.bg-c18 {
  background-color: #6c6c6c;
}

.bg-h-c18 {
  background-color: #6c6c6c;
}

.bc-c18 {
  border-color: #6c6c6c;
}

.text-c19 {
  color: #27bf2f;
}

.bg-c19 {
  background-color: #27bf2f;
}

.bg-h-c19 {
  background-color: #27bf2f;
}

.bc-c19 {
  border-color: #27bf2f;
}

.text-c20 {
  color: #ff6f06;
}

.bg-c20 {
  background-color: #ff6f06;
}

.bg-h-c20 {
  background-color: #ff6f06;
}

.bc-c20 {
  border-color: #ff6f06;
}

.text-c21 {
  color: #d73e3e;
}

.bg-c21 {
  background-color: #d73e3e;
}

.bg-h-c21 {
  background-color: #d73e3e;
}

.bc-c21 {
  border-color: #d73e3e;
}

/* Font Size */
.fs-38 {
  font-size: 38px;
}

.fs-37 {
  font-size: 37px;
}

.fs-36 {
  font-size: 36px;
}

.fs-35 {
  font-size: 35px;
}

.fs-34 {
  font-size: 34px;
}

.fs-33 {
  font-size: 33px;
}

.fs-32 {
  font-size: 32px;
}

.fs-31 {
  font-size: 31px;
}

.fs-30 {
  font-size: 30px;
}

.fs-29 {
  font-size: 29px;
}

.fs-28 {
  font-size: 28px;
}

.fs-27 {
  font-size: 27px;
}

.fs-26 {
  font-size: 26px;
}

.fs-25 {
  font-size: 25px;
}

.fs-24 {
  font-size: 24px;
}

.fs-23 {
  font-size: 23px;
}

.fs-22 {
  font-size: 22px;
}

.fs-21 {
  font-size: 21px;
}

.fs-20 {
  font-size: 20px;
}

.fs-19 {
  font-size: 19px;
}

.fs-18 {
  font-size: 18px;
}

.fs-17 {
  font-size: 17px;
}

.fs-16 {
  font-size: 16px;
}

.fs-15 {
  font-size: 15px;
}

.fs-14 {
  font-size: 14px;
}

.fs-13 {
  font-size: 13px;
}

.fs-12 {
  font-size: 12px;
}

.fs-11 {
  font-size: 11px;
}

.fs-10 {
  font-size: 10px;
}

.fs-9 {
  font-size: 9px;
}

.line-height-38 {
  line-height: 38px;
}

.line-height-37 {
  line-height: 37px;
}

.line-height-36 {
  line-height: 36px;
}

.line-height-35 {
  line-height: 35px;
}

.line-height-34 {
  line-height: 34px;
}

.line-height-33 {
  line-height: 33px;
}

.line-height-32 {
  line-height: 32px;
}

.line-height-31 {
  line-height: 31px;
}

.line-height-30 {
  line-height: 30px;
}

.line-height-29 {
  line-height: 29px;
}

.line-height-28 {
  line-height: 28px;
}

.line-height-27 {
  line-height: 27px;
}

.line-height-26 {
  line-height: 26px;
}

.line-height-25 {
  line-height: 25px;
}

.line-height-24 {
  line-height: 24px;
}

.line-height-23 {
  line-height: 23px;
}

.line-height-22 {
  line-height: 22px;
}

.line-height-21 {
  line-height: 21px;
}

.line-height-20 {
  line-height: 20px;
}

.line-height-19 {
  line-height: 19px;
}

.line-height-18 {
  line-height: 18px;
}

.line-height-17 {
  line-height: 17px;
}

.line-height-16 {
  line-height: 16px;
}

.line-height-15 {
  line-height: 15px;
}

.line-height-14 {
  line-height: 14px;
}

.line-height-13 {
  line-height: 13px;
}

.line-height-12 {
  line-height: 12px;
}

.line-height-11 {
  line-height: 11px;
}

.line-height-10 {
  line-height: 10px;
}

.line-height-9 {
  line-height: 9px;
}

/* Font-weight */
.fw-800 {
  font-weight: 800;
}

.fw-700 {
  font-weight: 700;
}

.fw-600 {
  font-weight: 600;
}

.fw-500 {
  font-weight: 500;
}

/* Height */
.h-700 {
  height: 700;
}

.h-650 {
  height: 650;
}

.h-600 {
  height: 600;
}

.h-550 {
  height: 550;
}

.h-500 {
  height: 500;
}

.h-450 {
  height: 450;
}

.buttonStyle {
  min-width: 134px;
  height: 43px;
  border-radius: 84px;
  margin: 10px;
  font-size: 14px;
}

.border-grey {
  border: 1px solid #3C4758;
}

.border-green {
  border: 1px solid #837F39;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/abstracts/variables.scss","webpack://./src/components/Company/Button/styles.scss","webpack://./src/assets/scss/abstracts/functions.scss"],"names":[],"mappings":"AAwEA,UAAA;AA2BE;EACE,cA3BO;ACtEX;;ADmGE;EACE,yBA9BO;AClEX;;ADkGE;EACE,yBAjCO;AC9DX;;ADiGE;EACE,qBApCO;AC1DX;;ADoFE;EACE,cA3BO;ACtDX;;ADmFE;EACE,yBA9BO;AClDX;;ADkFE;EACE,yBAjCO;AC9CX;;ADiFE;EACE,qBApCO;AC1CX;;ADoEE;EACE,cA3BO;ACtCX;;ADmEE;EACE,yBA9BO;AClCX;;ADkEE;EACE,yBAjCO;AC9BX;;ADiEE;EACE,qBApCO;AC1BX;;ADoDE;EACE,cA3BO;ACtBX;;ADmDE;EACE,yBA9BO;AClBX;;ADkDE;EACE,yBAjCO;ACdX;;ADiDE;EACE,qBApCO;ACVX;;ADoCE;EACE,cA3BO;ACNX;;ADmCE;EACE,yBA9BO;ACFX;;ADkCE;EACE,yBAjCO;ACEX;;ADiCE;EACE,qBApCO;ACMX;;ADoBE;EACE,cA3BO;ACUX;;ADmBE;EACE,yBA9BO;ACcX;;ADkBE;EACE,yBAjCO;ACkBX;;ADiBE;EACE,qBApCO;ACsBX;;ADIE;EACE,cA3BO;AC0BX;;ADGE;EACE,yBA9BO;AC8BX;;ADEE;EACE,yBAjCO;ACkCX;;ADCE;EACE,qBApCO;ACsCX;;ADZE;EACE,cA3BO;AC0CX;;ADbE;EACE,yBA9BO;AC8CX;;ADdE;EACE,yBAjCO;ACkDX;;ADfE;EACE,qBApCO;ACsDX;;AD5BE;EACE,cA3BO;AC0DX;;AD7BE;EACE,yBA9BO;AC8DX;;AD9BE;EACE,yBAjCO;ACkEX;;AD/BE;EACE,qBApCO;ACsEX;;AD5CE;EACE,cA3BO;AC0EX;;AD7CE;EACE,yBA9BO;AC8EX;;AD9CE;EACE,yBAjCO;ACkFX;;AD/CE;EACE,qBApCO;ACsFX;;AD5DE;EACE,cA3BO;AC0FX;;AD7DE;EACE,yBA9BO;AC8FX;;AD9DE;EACE,yBAjCO;ACkGX;;AD/DE;EACE,qBApCO;ACsGX;;AD5EE;EACE,cA3BO;AC0GX;;AD7EE;EACE,yBA9BO;AC8GX;;AD9EE;EACE,yBAjCO;ACkHX;;AD/EE;EACE,qBApCO;ACsHX;;AD5FE;EACE,cA3BO;AC0HX;;AD7FE;EACE,yBA9BO;AC8HX;;AD9FE;EACE,yBAjCO;ACkIX;;AD/FE;EACE,qBApCO;ACsIX;;AD5GE;EACE,cA3BO;AC0IX;;AD7GE;EACE,yBA9BO;AC8IX;;AD9GE;EACE,yBAjCO;ACkJX;;AD/GE;EACE,qBApCO;ACsJX;;AD5HE;EACE,cA3BO;AC0JX;;AD7HE;EACE,yBA9BO;AC8JX;;AD9HE;EACE,yBAjCO;ACkKX;;AD/HE;EACE,qBApCO;ACsKX;;AD5IE;EACE,cA3BO;AC0KX;;AD7IE;EACE,yBA9BO;AC8KX;;AD9IE;EACE,yBAjCO;ACkLX;;AD/IE;EACE,qBApCO;ACsLX;;AD5JE;EACE,cA3BO;AC0LX;;AD7JE;EACE,yBA9BO;AC8LX;;AD9JE;EACE,yBAjCO;ACkMX;;AD/JE;EACE,qBApCO;ACsMX;;AD5KE;EACE,cA3BO;AC0MX;;AD7KE;EACE,yBA9BO;AC8MX;;AD9KE;EACE,yBAjCO;ACkNX;;AD/KE;EACE,qBApCO;ACsNX;;AD5LE;EACE,cA3BO;AC0NX;;AD7LE;EACE,yBA9BO;AC8NX;;AD9LE;EACE,yBAjCO;ACkOX;;AD/LE;EACE,qBApCO;ACsOX;;AD5ME;EACE,cA3BO;AC0OX;;AD7ME;EACE,yBA9BO;AC8OX;;AD9ME;EACE,yBAjCO;ACkPX;;AD/ME;EACE,qBApCO;ACsPX;;AD5NE;EACE,cA3BO;AC0PX;;AD7NE;EACE,yBA9BO;AC8PX;;AD9NE;EACE,yBAjCO;ACkQX;;AD/NE;EACE,qBApCO;ACsQX;;ACxUA,cAAA;AAGE;EACE,eAAA;ADyUJ;;AC1UE;EACE,eAAA;AD6UJ;;AC9UE;EACE,eAAA;ADiVJ;;AClVE;EACE,eAAA;ADqVJ;;ACtVE;EACE,eAAA;ADyVJ;;AC1VE;EACE,eAAA;AD6VJ;;AC9VE;EACE,eAAA;ADiWJ;;AClWE;EACE,eAAA;ADqWJ;;ACtWE;EACE,eAAA;ADyWJ;;AC1WE;EACE,eAAA;AD6WJ;;AC9WE;EACE,eAAA;ADiXJ;;AClXE;EACE,eAAA;ADqXJ;;ACtXE;EACE,eAAA;ADyXJ;;AC1XE;EACE,eAAA;AD6XJ;;AC9XE;EACE,eAAA;ADiYJ;;AClYE;EACE,eAAA;ADqYJ;;ACtYE;EACE,eAAA;ADyYJ;;AC1YE;EACE,eAAA;AD6YJ;;AC9YE;EACE,eAAA;ADiZJ;;AClZE;EACE,eAAA;ADqZJ;;ACtZE;EACE,eAAA;ADyZJ;;AC1ZE;EACE,eAAA;AD6ZJ;;AC9ZE;EACE,eAAA;ADiaJ;;AClaE;EACE,eAAA;ADqaJ;;ACtaE;EACE,eAAA;ADyaJ;;AC1aE;EACE,eAAA;AD6aJ;;AC9aE;EACE,eAAA;ADibJ;;AClbE;EACE,eAAA;ADqbJ;;ACtbE;EACE,eAAA;ADybJ;;AC1bE;EACE,cAAA;AD6bJ;;ACrbE;EACE,iBAAA;ADwbJ;;ACzbE;EACE,iBAAA;AD4bJ;;AC7bE;EACE,iBAAA;ADgcJ;;ACjcE;EACE,iBAAA;ADocJ;;ACrcE;EACE,iBAAA;ADwcJ;;ACzcE;EACE,iBAAA;AD4cJ;;AC7cE;EACE,iBAAA;ADgdJ;;ACjdE;EACE,iBAAA;ADodJ;;ACrdE;EACE,iBAAA;ADwdJ;;ACzdE;EACE,iBAAA;AD4dJ;;AC7dE;EACE,iBAAA;ADgeJ;;ACjeE;EACE,iBAAA;ADoeJ;;ACreE;EACE,iBAAA;ADweJ;;ACzeE;EACE,iBAAA;AD4eJ;;AC7eE;EACE,iBAAA;ADgfJ;;ACjfE;EACE,iBAAA;ADofJ;;ACrfE;EACE,iBAAA;ADwfJ;;ACzfE;EACE,iBAAA;AD4fJ;;AC7fE;EACE,iBAAA;ADggBJ;;ACjgBE;EACE,iBAAA;ADogBJ;;ACrgBE;EACE,iBAAA;ADwgBJ;;ACzgBE;EACE,iBAAA;AD4gBJ;;AC7gBE;EACE,iBAAA;ADghBJ;;ACjhBE;EACE,iBAAA;ADohBJ;;ACrhBE;EACE,iBAAA;ADwhBJ;;ACzhBE;EACE,iBAAA;AD4hBJ;;AC7hBE;EACE,iBAAA;ADgiBJ;;ACjiBE;EACE,iBAAA;ADoiBJ;;ACriBE;EACE,iBAAA;ADwiBJ;;ACziBE;EACE,gBAAA;AD4iBJ;;ACviBA,gBAAA;AAGE;EACE,gBAHC;AD2iBL;;ACziBE;EACE,gBAEG;AD0iBP;;AC7iBE;EACE,gBAEG;AD8iBP;;ACjjBE;EACE,gBAEG;ADkjBP;;AC/iBA,WAAA;AAGE;EACE,WAHK;ADmjBT;;ACjjBE;EACE,WAEO;ADkjBX;;ACrjBE;EACE,WAEO;ADsjBX;;ACzjBE;EACE,WAEO;AD0jBX;;AC7jBE;EACE,WAEO;AD8jBX;;ACjkBE;EACE,WAEO;ADkkBX;;AAzmBA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA4mBF;;AA1mBA;EACE,yBAAA;AA6mBF;;AA3mBA;EACE,yBAAA;AA8mBF","sourcesContent":["$primary-color: #222;\n$primary-color-dark: #222;\n$light-gray: #d6d6d6;\n$ash: #f7f7f7;\n$light-ash: #efefef;\n$primary-bg: #180065;\n$gold: #c89a32;\n$orange: #f58d45;\n$white: #fff;\n$green: #0a8c5b;\n$green-18: #837F39;\n$black: #000;\n$black-50: #565958;\n$black-33: #333536;\n$black-1c: #1c2c25;\n$grey: #e8e4e4;\n$ash-gray: #c4c4c4;\n$grey-65: #656565;\n$grey-50: #8c8c8c;\n$black-4D: #4d4d4d;\n$full-height: 100vh;\n$violet: #180065;\n$light-violet: #796ba6;\n$light-blue: #edf1fb;\n$light-violet50: #d6def5;\n$light-violet: #796ba6;\n$pink: #da274a;\n$skyblue: #3fc1e8;\n$cyanBlue: #07e1c7;\n$blue: #3783f5;\n$green-2f: #27bf2f;\n$green-href: #0f994e;\n$bg-ash: #f9f9f9;\n$label-ash: #575757;\n$light-ash: #efefef;\n$gray-span: #909090;\n$gray-6c: #6c6c6c;\n$calender-header: #aebfef;\n$tick-bg: #bf27276e;\n$thead-bg: #aebfef80;\n$red-dark: #ff0000;\n$blue-btn: #d4defb;\n$col-555555: #555555;\n$pagination-bg: #aebfef;\n\n$black-5: rgba(0, 0, 0, 0.5);\n$black-2: rgba(0, 0, 0, 0.2);\n$prev-btn: #f2f2f2;\n$c1: #e5e5e5;\n$c2: #180065;\n$c3: #f9f9f9;\n$c4: #556080;\n$c5: #6c6c6c;\n$c6: #dff5fb;\n$c7: #dff9e1;\n$c8: #dfedff;\n$c9: #fee7e5;\n\n$c10: #b9e1ec;\n$c11: #bfedc2;\n$c12: #b8ceeb;\n$c13: #f2d0cd;\n$c14: #0d0d0d;\n$c15: #424242;\n$c16: #d7dff7;\n$c17: $calender-header;\n$c18: $gray-6c;\n$c19: $green-2f;\n$col-CC2B5A: \"#CC2B5A\";\n$light-bg: $light-gray;\n$c20: #ff6f06;\n$c21: #d73e3e;\n/* Color */\n$myColors: (\n  \"c1\": $c1,\n  \"c2\": $c2,\n  \"c3\": $c3,\n  \"c4\": $c4,\n  \"c5\": $c5,\n  \"c6\": $c6,\n  \"c7\": $c7,\n  \"c8\": $c8,\n  \"c9\": $c9,\n  \"c10\": $c10,\n  \"c11\": $c11,\n  \"c12\": $c12,\n  \"c13\": $c13,\n  \"c14\": $c14,\n  \"c15\": $c15,\n  \"c16\": $c16,\n  \"c17\": $c17,\n  \"c18\": $c18,\n  \"c19\": $c19,\n  \"c20\": $c20,\n  \"c21\": $c21\n);\n\n@each $name, $colors in $myColors {\n  $index: index($myColors, $colors);\n  .text-#{$name} {\n    color: $colors;\n  }\n  .bg-#{$name} {\n    background-color: $colors;\n  }\n  .bg-h-#{$name} {\n    background-color: $colors;\n  }\n  .bc-#{$name} {\n    border-color: $colors;\n  }\n}\n","@import '../../../assets/scss/abstracts/abstracts';\n.buttonStyle{\n  min-width:134px;\n  height:43px;\n  border-radius: 84px;\n  margin:10px;\n  font-size:14px;\n}\n.border-grey{\n  border:1px solid #3C4758;\n}\n.border-green{\n  border:1px solid #837F39;\n}","$root-font-size: 16px;\n\n@function fontSize($size) {\n  $remSize: $size / $root-font-size;\n  @return #{$remSize}rem;\n}\n\n/* Font Size */\n$fs: 38;\n@while $fs > 8 {\n  .fs-#{$fs} {\n    font-size: $fs * 1px;\n  }\n  $fs: $fs - 1;\n}\n\n//Line-Height\n$line-height: 38;\n@while $line-height > 8 {\n  .line-height-#{$line-height} {\n    line-height: $line-height * 1px;\n  }\n  $line-height: $line-height - 1;\n}\n\n/* Font-weight */\n$fw: 800;\n@while $fw > 400 {\n  .fw-#{$fw} {\n    font-weight: $fw;\n  }\n  $fw: $fw - 100;\n}\n\n/* Height */\n$height: 700;\n@while $height > 400 {\n  .h-#{$height} {\n    height: $height;\n  }\n  $height: $height - 50;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
